var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { List } from '../index';
import CoreMenuItem from './CoreMenuItem';
export default memo((_a) => {
    var { menu = [], component = 'nav', activeMenuColor = '' } = _a, otherProps = __rest(_a, ["menu", "component", "activeMenuColor"]);
    return (_jsx(List, Object.assign({ component: component }, otherProps, { children: menu.map((menuItem, index) => ((!menuItem.isHidden && (_jsx(CoreMenuItem, { item: menuItem, activeMenuColor: activeMenuColor }, index))))) })));
});
//# sourceMappingURL=index.js.map